import { render, staticRenderFns } from "./fine.vue?vue&type=template&id=8cbb47a0&scoped=true&"
import script from "./fine.vue?vue&type=script&lang=js&"
export * from "./fine.vue?vue&type=script&lang=js&"
import style0 from "./fine.vue?vue&type=style&index=0&id=8cbb47a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cbb47a0",
  null
  
)

export default component.exports